import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 查询拼团商品列表
export function getGroupBuyProductList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy/queryGroupBuyProduct',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品列表
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取拼团商品详情
export function getGroupBuyProductDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy/queryGroupBuyProduct',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增拼团商品
export function saveGroupBuyProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy/saveGroupBuyProduct',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新拼团商品
export function updateGroupBuyProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy/updateGroupBuyProduct',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除拼团商品
export function deleteGroupBuyProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/groupBuy/deleteGroupBuyProduct',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}